import { localToday } from "../../../../utils";
import {
  BrokerageTransferDirection,
  BrokerageTransferFormValues,
} from "./types";

export const FORM_ID = "brokerage-transfer";

export const DIRECTION_SEGMENTS: Array<{
  value: BrokerageTransferDirection;
  label: string;
}> = [
  { value: "DEPOSIT", label: "Deposit" },
  { value: "WITHDRAWAL", label: "Withdraw" },
];

/** A fresh date is required whenever the panel opens or resets. */
export const createDefaultBrokerageTransfer =
  (): BrokerageTransferFormValues => ({
    direction: "DEPOSIT",
    amountEur: "",
    date: localToday(),
    externalAccount: null,
    note: "",
  });
